import React from 'react';

import ClassNames from 'classnames';
import _ from 'lodash';

import IDVerificationActions from './../../actions/IDVerificationActions.js';
import {Labels, ReactKeyOther} from './../../constants/IDVerificationConstants.js';

import TextInput from './../Common/TextInput.jsx';
import RadioInput from './../Common/RadioInput.jsx';
import SelectInput from './../Common/SelectInput.jsx';
import CancelDoneButtons from './../Common/CancelDoneButtons.jsx';
import InlineInfoMessage from './../Common/InlineInfoMessage.jsx';
import InlineInfoButton from './../Common/InlineInfoButton.jsx';
import ContentService from './../../services/ContentService';

export default class IDVerificationForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isHelpHidden_verifiedFrom: true
        }
    }

    handleCancelEditDocument(docId, investorId) {
        IDVerificationActions.cancelEditIDVerificationForm(docId, investorId);
    }

    handleDoneEditDocument(docId, investorId) {
        IDVerificationActions.finishEditIDVerificationForm(docId, investorId);
        this.props.updateVerificationDocument();
    }

    handleChangeDocumentType(e) {
        IDVerificationActions.changeIDVerificationType(this.props.docId, this.props.investorId, e.target.value);
    }

    handleUpdateInputField(docId, investorId, event) {
        const formInputValue = event.target.value;
        const formInputName = event.target.model;

        IDVerificationActions.updateIDVerificationForm(docId, investorId, formInputValue, formInputName);
    }

    getTypeDescriptions(typeTitle, typeDescription) {
        let descriptions = [];
        if (typeTitle) {
            descriptions.push(<p className="digital-consent-form__descTitle" key="typeTitle">{typeTitle}</p>);
        }
        if (typeDescription) {
            descriptions.push(<p className="digital-consent-form__desc" key="typeDescription">{typeDescription}</p>);
        }
        return descriptions;
    }

    getFieldMode(f, key, target, idx) {
        const isValid = (f.isValid === false) ? false : true;
        const value = f.value || f.defaultValue || '';
        const errorMessage = !isValid ? f.errorList.errorMessage : undefined;
        const errorHeading = !isValid ? f.errorList.errorHeading : undefined;
        const defaultValue = f.value || f.defaultValue || undefined;

        let fieldset = [];
        if (f.component === 'SELECT') {
            fieldset.push(<SelectInput id={key + '__' + idx}
                placeholder={f.placeholder || ('Select ' + f.label.toLowerCase()) }
                model={f.model}
                value={value}
                searchable={false}
                clearable={false}
                options={f.selectOptions}
                onChange={this.handleUpdateInputField.bind(this, target.props.docId, target.props.investorId) }
                onBlur={this.handleUpdateInputField.bind(this, target.props.docId, target.props.investorId) }
                noRequiredValidation={true}
                className={f.className || 'select-input-lg'}
                isValid={isValid}
                isHidden={false}
                errorHeading={errorHeading}
                errorMessage={errorMessage}
                key= {key + '__' + idx} />);
        } else if (f.component === 'TEXTINPUT') {
            fieldset.push(<TextInput
                id={key + '__' + idx}
                placeholder={f.placeholder || ('Enter ' + f.label.toLowerCase()) }
                model={f.model}
                value={value}
                isValid={isValid}
                mandatory={f.mandatory}
                isHidden={false}
                errorHeading={errorHeading}
                errorMessage={errorMessage}
                defaultValue={defaultValue}
                maxLength={f.maxLength}
                onBlur={this.handleUpdateInputField.bind(this, target.props.docId, target.props.investorId) }
                className={f.className || 'form-input'}
                key= {key + '__' + idx} />);
        } else if (f.component === 'RADIOBUTTONLIST') {
            fieldset.push(
                <RadioInput id={key + '__' + idx}
                    key={key + '__' + idx}
                    data={f.options}
                    isHidden={false}
                    errorHeading={errorHeading}
                    errorMessage={errorMessage}
                    isValid={isValid}
                    value={value}
                    label=""
                    onChange={this.handleUpdateInputField.bind(this, target.props.docId, target.props.investorId)}
                    model={f.model} />
            );
        }
        return fieldset;
    }

    handleClickHelp(model) {
        if (model === 'verifiedFrom') {
            this.setState({ isHelpHidden_verifiedFrom: !this.state.isHelpHidden_verifiedFrom });
        }
    }

    getHelpMessage(helpCopy, model, idx) {
        let help = null;
        let content = ContentService.getContent();
        if (helpCopy) {
            help = (<div key={'idv__help-' + model + '__' + idx} className="verifiedFrom">
                <InlineInfoButton helpText={content.idVerification.helpCopy[helpCopy]} isHidden={this.state.isHelpHidden_verifiedFrom}
                    toggleShowHideHelpText={this.handleClickHelp.bind(this, model) } />
                <InlineInfoMessage message={content.idVerification.helpCopy[helpCopy]} isHidden={this.state.isHelpHidden_verifiedFrom} />
            </div>);
        }

        return help;
    }

    getFormFields(fields, key, target) {
        let fieldSet = [];

        _.each(fields, (f, idx) => {
            fieldSet.push(<div className="digital-consent-form__fieldset digital-consent-form__marginBottom30 digital-consent-form__${f.model}" key={key + '__' + f.model}>
                <div className="form-section">
                    <div className="form-label-section">
                        <label htmlFor={key + '__' + f.model + '__' + idx}>{f.label}</label>
                        {this.getHelpMessage(f.helpCopy, f.model, idx) }
                    </div>
                    {this.getFieldMode(f, (key + '__' + f.model), target, idx) }
                </div>
            </div>);
        });

        return fieldSet;
    }

    getSelectTypeDropdowns(uniqueKey, options, reactKey, target) {

        let dropdowns = [];

        const mainOptions = _.sortBy(_.filter(options, function(o) { return o.isMain; }), 'sortIndex');
        const nonMainOptions = _.sortBy(_.filter(options, function(o) { return !o.isMain; }), 'type');

        let showSubTypeOptions = _.some(nonMainOptions, { 'reactKey': reactKey }) || reactKey === ReactKeyOther;

        let mainTypeOptionValue;
        let subTypeOptionValue;

        if (showSubTypeOptions) {
            mainTypeOptionValue = ReactKeyOther;
            subTypeOptionValue = reactKey;
        } else {
            mainTypeOptionValue = reactKey;
            subTypeOptionValue = null;
        }

        if (mainOptions) {
            dropdowns.push(<SelectInput id={uniqueKey + '__documentTypeMainDropdown'}
             key={uniqueKey + '__documentTypeMainDropdown'}
             className={'select-input-lg digital-consent-form__documentTypeMainDropDown'}
             options={mainOptions} value={mainTypeOptionValue}
             searchable={false} label={Labels.SELECT_DOCUMENT_TYPE_LABEL}
             autoblur={false} clearable={false} isHidden={false}
             onChange={target.handleChangeDocumentType.bind(target)}
             placeholder={Labels.SELECT_DOCUMENT_TYPE_LABEL}/>);
        }

        if (showSubTypeOptions) {
            dropdowns.push(<SelectInput id={uniqueKey + '__documentTypeOtherDropdown'}
             key={uniqueKey + '__documentTypeOtherDropdown'}
             className={'select-input-lg digital-consent-form__documentTypeOtherDropDown'}
             options={nonMainOptions} value={subTypeOptionValue}
             searchable={false} autoblur={false} isHidden={!showSubTypeOptions}
             clearable={false} onChange={target.handleChangeDocumentType.bind(target)}/>);
        }
        return dropdowns;
    }

    render() {
        const docIdOfInvestor = 'investor' + this.props.investorId + '__docId' + this.props.docId;
        const uniqueKey = 'digital-consent-form__investor' + docIdOfInvestor;
        const Styles = ClassNames('col-xs-10 col-md-12 digital-consent-form', uniqueKey, 'digital-consent-form__editMode');
        const target = this;
        const isInOtherIntermediateState = this.props.model.reactKey === ReactKeyOther;
        const allFieldsValidated = this.props.model.isValid;

        const selectDropDowns = this.getSelectTypeDropdowns(uniqueKey, this.props.options, this.props.model.reactKey, target);
        const typeDescriptions = isInOtherIntermediateState ? null : this.getTypeDescriptions(this.props.model.type, this.props.model.typeDescription);
        const fields = this.getFormFields(this.props.model.meta, docIdOfInvestor, target);

        return (
            <div className={Styles}>
                <div className="form-section">
                    <div>
                        {selectDropDowns}
                        {typeDescriptions}
                    </div>
                </div>
                {fields}
                <div className="row">
                    <div className="col-xs-12">
                        <CancelDoneButtons cancelDoneMainClassName={'digital-consent-form__cancelDoneButtons ' + uniqueKey + '__cancelDone'}
                            index={this.props.investorId}
                            onClickCancel={this.handleCancelEditDocument.bind(this, this.props.docId, this.props.investorId) }
                            key={uniqueKey + '__cancelDone'}
                            onClickDone={this.handleDoneEditDocument.bind(this, this.props.docId, this.props.investorId) }
                            disabled={!allFieldsValidated || isInOtherIntermediateState}/>
                    </div>
                </div>
            </div>);
    }
}

IDVerificationForm.propTypes = {
    model: React.PropTypes.object.isRequired,
    investorId: React.PropTypes.number.isRequired,
    docId: React.PropTypes.string.isRequired,
    options: React.PropTypes.array.isRequired,
    updateVerificationDocument: React.PropTypes.func.isRequired
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/IDVerification/IDVerificationForm.jsx